const array2set = (xs) => {
	var set = {};
	for (var x of xs || []) set[x] = true;
	return set;
};

export { array2set };
